<template lang="html">
	<div :class='`global-navigation-container ${componentParams.template}`'>
		<template v-if='componentParams.template === "top"'>
			<menu-top :data='api_response'></menu-top>
		</template>
	</div>
</template>
<script>
exports.default = {
	props: {
		dataParams: {
			type: String,
			required: true
		}
	},
	components: {
		'menu-top': require('./navigations/top.vue')
	},
	data: () => {
		return {
			api_response: {}
		}
	},
	computed: {
		componentParams() {
			let str = this.dataParams.replace(/'/g, '"');
			return JSON.parse(str);
		}
	},
	beforeMount() {
		let method = this.componentParams.method;
		let url = this.componentParams.url;
		let custom_request = this.componentParams.request;
		let options = {
			responseType: 'json'
		}
		if(method.toLowerCase() == 'post') {
			// options.params = custom_request;
			// options.body = custom_request;
			options.emulateJSON = true;
			this.$http[method](url, custom_request, options).then(success).catch(error);
		}
		else if(method.toLowerCase() == 'get') {
			options.params = custom_request;
			this.$http[method](url, options).then(success).catch(error);
		}
		function success(response) {
			// console.log(response);
			this.api_response = response.body.api_response;
		}
		function error(err) {
			console.log(err);
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Navigation.vue?73a9143a